import React from "react";
import { Link } from "react-router-dom";

export const AuroraHeader = ({ compact = false }) => {
  return (
    <header className="w-full border-b border-[#A88059]/40 bg-[#FAF5EE]" data-testid="aurora-header">
      <div className="max-w-6xl mx-auto px-6 sm:px-10 py-6 flex items-center justify-between gap-6">
        <Link to="/" data-testid="aurora-logo-link" className="block">
          <h1
            className="font-heading text-[#A88059] tracking-[0.25em]"
            style={{ fontSize: compact ? "18px" : "22px" }}
          >
            AURORA INSIGHTS
          </h1>
          {!compact && (
            <p className="font-body italic text-[#6B4D2B] text-sm mt-1">
              Navigating Regional Complexity through Insights
            </p>
          )}
        </Link>
        <div className="hidden md:block label-eyebrow text-right" data-testid="header-locations">
          Kuala Lumpur · Bangkok · Singapore
        </div>
      </div>
    </header>
  );
};

export const AuroraFooter = () => (
  <footer
    className="w-full border-t border-[#A88059]/40 mt-20 py-8"
    data-testid="aurora-footer"
  >
    <div className="max-w-6xl mx-auto px-6 sm:px-10 flex flex-col sm:flex-row items-center justify-between gap-3">
      <div className="label-eyebrow">
        info@aurorainsights.co &nbsp;·&nbsp; aurorainsights.co
      </div>
      <div className="label-eyebrow" data-testid="footer-locations">
        Kuala Lumpur · Bangkok · Singapore
      </div>
      <Link
        to="/admin/login"
        className="label-eyebrow hover:text-[#190F08] transition-colors"
        data-testid="footer-admin-link"
      >
        Aurora Console →
      </Link>
    </div>
  </footer>
);
